import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, Int32Field, StringField, BooleanField, Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class SpielwerkDeviceBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new SpielwerkDeviceBox({
            uuid,
            graph,
            name: "SpielwerkDeviceBox",
            pointerRules: {
                accepts: [Pointers.Device, Pointers.Selection, Pointers.MetaData],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "SpielwerkDeviceBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({ type: "device", deviceType: "midi-effect" });
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitSpielwerkDeviceBox, this);
    }
    get tags() {
        return SpielwerkDeviceBox.Tags;
    }
    get host() {
        return this.getField(1);
    }
    get index() {
        return this.getField(2);
    }
    get label() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    get code() {
        return this.getField(10);
    }
    get parameters() {
        return this.getField(11);
    }
    get samples() {
        return this.getField(12);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "host",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.MIDIEffectHost, true),
            2: Int32Field.create({
                parent: this,
                fieldKey: 2,
                fieldName: "index",
                deprecated: false,
                pointerRules: NoPointers,
            }, "index", ""),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                deprecated: false,
                pointerRules: NoPointers,
            }, false),
            10: StringField.create({
                parent: this,
                fieldKey: 10,
                fieldName: "code",
                deprecated: false,
                pointerRules: NoPointers,
            }, ""),
            11: Field.hook({
                parent: this,
                fieldKey: 11,
                fieldName: "parameters",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.Parameter],
                    mandatory: false,
                    exclusive: false,
                },
            }),
            12: Field.hook({
                parent: this,
                fieldKey: 12,
                fieldName: "samples",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.Sample],
                    mandatory: false,
                    exclusive: false,
                },
            }),
        };
    }
}
